import { useState ,useEffect,} from "react";
import { useClient } from "./Hooks/useClient";
import { useNavigate, useParams, useLocation, } from "react-router-dom";
import { Spinner, } from "../../Components/Common";
import { ArrowLeft,} from "lucide-react";
import { CLIENT_MODES } from "./constants";
import { VIEW, EDIT, CLIENT_MASTER, } from "../../routes";

const ClientActions = () => {
    const param = useParams();
    const location = useLocation();
    const navigate = useNavigate();
    const [mode, setMode] = useState(CLIENT_MODES.VIEW);
    const {
        loading,
        fetchClientById,
        newClient,
        updateClientDetails,
    } = useClient();

    const [client, setClient] = useState({
        name: "",
        contact_person_name: "",
        mobile: "",
        address: "",
        gst_details: ""
    });

    const fetchClientDetails = async (instanceId) => {
        const ClientData = await fetchClientById(instanceId);
        if (ClientData) {
            setClient(ClientData);
        }
    };

    // Handle input change for create/edit form
    const handleInputChange = (e) => {
        const { name, value } = e.target;
        setClient((prev) => ({ ...prev, [name]: value }));
    };
    // Save client
    const handleSaveClient = async () => {

            if (mode === CLIENT_MODES.CREATE) {
                await newClient(client);
            } else {
                await updateClientDetails(param.instanceId, client);
            }
        navigate(CLIENT_MASTER);
    };

    const renderClientDetails = () => {
        return loading ? (
            <div className="flex justify-center items-center h-[30vh]">
                <Spinner />
            </div>
        ) : (
                <div className="flex justify-center items-start py-6">
                    <div
                        className={`w-full bg-white shadow-md rounded-2xl p-6 transition-all duration-300 
      ${mode === CLIENT_MODES.VIEW ? "max-w-lg min-h-[300px]" : "max-w-xl"}`}
                    >
                        <h2 className="text-2xl font-bold text-center text-primary mb-6">
                            Client Details
                        </h2>
                        <div className={`grid gap-x-6 gap-y-4 ${mode ===CLIENT_MODES.VIEW ?  "grid-cols-2" : "grid-cols-1" } md:grid-cols-2 `}>
                            {/* Client Name */}
                            <div className="mt-0.5">
                                <p className={`text-sm ${mode !== CLIENT_MODES.VIEW ? "font-bold text-gray-700 " : "font-normal text-gray-500 "
                                    }`}>Client Name
                                    {mode !== CLIENT_MODES.VIEW && (
                                    <sub className="text-red-500 top-0"> *</sub>
                                    )}
                                </p>
                                {mode === CLIENT_MODES.VIEW ? (
                                    <p className="font-semibold text-gray-800 mt-0.5">
                                        {client?.name || "-"}
                                    </p>
                                ) : (
                                    <input
                                        type="text"
                                        name="name"
                                        value={client.name || ""}
                                        onChange={handleInputChange}
                                            className="border border-gray-300 rounded-lg px-3 py-2 w-full focus:ring-1 focus:ring-blue-500 focus:outline-none resize-none"
                                        placeholder="Enter Client Name"
                                    />
                                )}
                            </div>

                            {/* Contact Person */}
                            <div className="mt-0.5">
                                <p className={`text-sm ${mode !== CLIENT_MODES.VIEW ? "font-bold text-gray-700 " : "font-normal text-gray-500 "
                                    }`}>Contact Person Name
                                    {mode !== CLIENT_MODES.VIEW && (
                                    <sub className="text-red-500 top-0"> *</sub>
                                    )}
                                </p>
                                {mode === CLIENT_MODES.VIEW ? (
                                    <p className="font-semibold text-gray-800 mt-0.5">
                                        {client?.contact_person_name || "-"}
                                    </p>
                                ) : (
                                    <input
                                        type="text"
                                        name="contact_person_name"
                                        value={client.contact_person_name || ""}
                                        onChange={handleInputChange}
                                            className="border border-gray-300 rounded-lg px-3 py-2 w-full focus:ring-1 focus:ring-blue-500 focus:outline-none resize-none"
                                        placeholder="Enter Contact Person Name"
                                    />
                                )}
                            </div>

                            {/* Mobile */}
                            <div className="mt-2">
                                <p className={`text-sm  ${mode !== CLIENT_MODES.VIEW ? "font-bold text-gray-700" : "font-normal text-gray-500"
                                    }`}>Mobile No
                                    {mode !== CLIENT_MODES.VIEW && (
                                    <sub className="text-red-500 top-0"> *</sub>
                                    )}
                                </p>
                                {mode === CLIENT_MODES.VIEW ? (
                                    <p className="font-semibold text-gray-800 mt-0.5">
                                        {client?.mobile || "-"}
                                    </p>
                                ) : (
                                    <input
                                        type="text"
                                        name="mobile"
                                        value={client.mobile || ""}
                                        onChange={handleInputChange}
                                            className="border border-gray-300 rounded-lg px-3 py-2 w-full focus:ring-1 focus:ring-blue-500 focus:outline-none resize-none"
                                        placeholder="Enter Mobile Number"
                                        maxLength={10}
                                    />
                                )}
                            </div>

                            {/* GST Details */}
                            <div className="mt-2">
                                <p className={`text-sm ${mode !== CLIENT_MODES.VIEW ? "font-bold text-gray-700" : "font-normal text-gray-500"
                                        }`} >GSTIN
                                    {mode !== CLIENT_MODES.VIEW && (
                                    <sub className="text-red-500 top-0"> *</sub>
                                    )}
                                </p>
                                {mode === CLIENT_MODES.VIEW ? (
                                    <p className="font-semibold text-gray-800 mt-0.5">
                                        {client?.gst_details || "-"}
                                    </p>
                                ) : (
                                    <input
                                        type="text"
                                        name="gst_details"
                                        value={client.gst_details || ""}
                                        onChange={handleInputChange}
                                        className="border border-gray-300 rounded-lg px-3 py-2 w-full focus:ring-1 focus:ring-blue-500 focus:outline-none resize-none"
                                        placeholder="Enter GST Details"
                                    />
                                )}
                            </div>

                            {/* Address */}
                            <div className="mt-2">
                                <p
                                    className={`text-sm  ${mode !== CLIENT_MODES.VIEW ? "font-bold text-gray-700" : "font-normal text-gray-500"
                                        }`} >Address
                                    {mode !== CLIENT_MODES.VIEW && (
                                    <sub className="text-red-500 top-0"> *</sub>
                                    )}
                                </p>
                                {mode === CLIENT_MODES.VIEW ? (
                                    <p className="font-semibold text-gray-800 mt-0.5">
                                        {client?.address || "-"}
                                    </p>
                                ) : (
                                    <textarea
                                        name="address"
                                        value={client.address || ""}
                                        onChange={handleInputChange}
                                        className="w-[290px] md:min-w-[530px] border border-gray-300 rounded-lg px-3 py-2 focus:ring-1 focus:ring-blue-500 focus:outline-none resize-none"
                                        placeholder="Enter Address"
                                        rows={2}
                                    />
                                )}
                            </div>
                        </div>
                        {/* Save Button */}
                        {mode !== CLIENT_MODES.VIEW && (
                            <div className="flex justify-end gap-2 border-gray-200 mt-1">
                                <button
                                    onClick={handleSaveClient}
                                    className="px-5 py-2 bg-primary text-white flex justify-center shadow hover:shadow-lg hover:bg-secondary active:scale-95 transition-all text-sm font-medium mr-4 mt-3"
                                >
                                    {mode === CLIENT_MODES.CREATE ? "Create" : "Update"}
                                </button>
                            </div>
                        )}
                    </div>
                </div>
        );
    };

    useEffect(() => {
        if (location.pathname.includes(EDIT) && param.instanceId) {
            setMode(CLIENT_MODES.EDIT);
            fetchClientDetails(param.instanceId);
        }
        else if (location.pathname.includes(VIEW) && param.instanceId) {
            setMode(CLIENT_MODES.VIEW);
            fetchClientDetails(param.instanceId);
        }
        else {
            setMode(CLIENT_MODES.CREATE);
        }
    }, [param.instanceId, location.pathname]);

    return (
        <div className="p-6">
            <div className="mb-4">
                <span
                    onClick={() => navigate(CLIENT_MASTER)}
                    className="inline-flex items-center text-blue-600 hover:text-blue-800 cursor-pointer gap-1"
                >
                    <ArrowLeft size={20} />
                    <h1 className="text-xl text-secondary font-semibold">
                        {mode === CLIENT_MODES.CREATE
                            ? "Create Client"
                            : mode === CLIENT_MODES.EDIT
                                ? "Edit Client"
                                : "Client Details"}
                    </h1>
                </span>
            </div>
            {/* Two Column Layout */}
            <div className="grid grid-cols-1 lg:grid-cols-1 gap-6">
                    {renderClientDetails()}
            </div>
        </div>

    );
};

export default ClientActions;
